// extracted by mini-css-extract-plugin
module.exports = {"web_setting_business":"web_setting_business--2vIrK"};